:host {
  height: auto;
  width: auto;
  --content-max-width: calc(var(--spacer) * 18);
}

:host {
  --default-chip-background: var(--chart-050-hover);
  --hover-chip-background: var(--chart-100-pressed);
  --focus-chip-background: var(--blue-layout-302-active-focus);
  --selected-chip-background: var(--blue-layout-303-active);
  --ripple-effect-background: var(--grey-layout-200-disabled);
  --content-color: var(--main-titles-inputs-600);
}

:host([color='negative']) {
  --default-chip-background: var(--red-layout-300-primary);
  --hover-chip-background: var(--red-layout-300-primary);
  --focus-chip-background: var(--red-layout-300-primary);
  --ripple-effect-background: var(--chart-300-icon-buttons);
  --content-color: var(--white-layout-300-primary);
}

:host([color='primary']) {
  --default-chip-background: var(--blue-layout-303-active);
  --hover-chip-background: var(--blue-layout-301-active);
  --focus-chip-background: var(--blue-layout-501-focus);
  --ripple-effect-background: var(--blue-layout-501-focus);
  --content-color: var(--white-layout-300-primary);
}

.chips-group {
  display: flex;
  flex-wrap: wrap;
  cursor: default;
}

.chip-item-container {
  height: calc(var(--spacer) * 3);
  cursor: pointer;
  display: flex;
  align-items: center;
  border: 1px solid transparent;

  background: var(--default-chip-background);
  border-radius: calc(var(--spacer) * 2);

  position: relative;
  overflow: hidden;
  margin: calc(var(--spacer) / 2);

  .icon {
    border-radius: 50%;
    margin: calc(var(--spacer) * 0.625);

    &::part(svgIcon) {
      fill: var(--chart-300-icon-buttons);
    }
  }

  .thumbnail {
    margin-left: var(--spacer);
  }

  .ds-icon-delete_large {
    background: var(--default-chip-background);
    color: var(--body-text-arrows-400);

    margin-left: calc(var(--spacer) + var(--spacer) * 0.625);
    overflow: hidden;
  }

  .content {
    max-width: var(--content-max-width);
    font-family: var(--font-family-secondary);
    font-size: var(--body-size-medium);
    margin: calc(var(--spacer) / 2) var(--spacer);
    color: var(--content-color);
  }
}

:host([disabled]) {
  --content-color: var(--grey-layout-200-disabled);

  gz-tooltip {
    pointer-events: none;
  }

  .chip-item-container {
    cursor: default;
    outline: none;
    .icon::part(svgIcon) {
      fill: var(--content-color);
    }
  }
}

:host(:not([disabled]):not([readonly]):focus) {
  .chip-item-container {
    background: var(--focus-chip-background);
    outline: none;
    border: 1px solid var(--blue-layout-501-focus);

    .ds-icon-delete_large {
      background: var(--focus-chip-background);
    }
  }
}

:host([readonly]) {
  .chip-item-container {
    outline: none;
  }
}

:host(:hover) {
  cursor: pointer;

  .chip-item-container {
    background: var(--hover-chip-background);
  }
}

:host([readonly]:hover) {
  cursor: default;

  .chip-item-container {
    cursor: default;
    background: var(--default-chip-background);
  }
}

:host([selected]) {
  --content-color: var(--white-layout-300-primary);

  .chip-item-container {
    background: var(--selected-chip-background);

    .icon::part(svgIcon) {
      fill: var(--white-layout-300-primary);
    }

    .thumbnail::part(svgIcon) {
      fill: var(--white-layout-300-primary);
    }
  }
}

.ripple {
  width: 100%;
  height: 100%;

  position: absolute;
  border-radius: 24px;
  transform: scaleX(0);
  animation: ripple 400ms ease-out;
  background: var(--ripple-effect-background);
  opacity: 0;
}

@keyframes ripple {
  0% {
    opacity: 1;
  }

  30% {
    background: var(--ripple-effect-background);
    opacity: 0.5;
  }

  to {
    transform: scaleX(2);
  }
}
